
// NATIVE 
import { useEffect, useState } from 'react'


// INSTALLED 
import { Button, Divider } from '@mui/material';


// CUSTOM 
import { mtDividerUpTable } from '../../commons';
import { hasPemissions } from '../../commons/utils';
import { TableAreas } from '../../components/tables/TableAreas';
import { DialogArea } from '../../components/modals/areas/DialogArea';
import { BreadCrumbsAndTitle } from '../../components/generics/BreadCrumbsAndTitle';
import { AlertsInformativos } from '../../components/generics/AlertsInformativos';
import { alertInformativo } from '../../commons/texts/textAlertsInformativos';






/**
 * The `Areas` component is responsible for rendering the areas management page.
 * It includes a breadcrumb navigation, a button to create a new area, and a table displaying existing areas.
 * 
 * @component
 * 
 * @example
 * return (
 *   <Areas />
 * )
 * 
 * @returns {JSX.Element} The rendered component.
 * 
 * @remarks
 * This component uses the `useState` and `useEffect` hooks to manage state and side effects.
 * It checks for the necessary permissions to create a new area and conditionally renders the "Crear Area" button.
 * 
 * @function
 * @name Areas
 * 
 * @hook
 * @name useState
 * @description Manages the state for modal visibility (`modalCreate`) and creation permissions (`canCreate`).
 * 
 * @hook
 * @name useEffect
 * @description Calls `hasPrmissionsCreate` on component mount to check for creation permissions.
 * 
 * @async
 * @function
 * @name hasPrmissionsCreate
 * @description Checks if the user has permissions to create a new area and updates the state accordingly.
 * 
 * @function
 * @name openModal
 * @description Sets the `modalCreate` state to `true` to open the creation modal.
 * 
 * @function
 * @name handleCloseModalCrear
 * @description Sets the `modalCreate` state to `false` to close the creation modal.
 * 
 * @component
 * @name BreadCrumbsAndTitle
 * @description Renders the breadcrumb navigation and title for the page.
 * 
 * @component
 * @name Button
 * @description Renders the "Crear Area" button if the user has creation permissions.
 * 
 * @component
 * @name Divider
 * @description Renders a divider between the button and the table.
 * 
 * @component
 * @name DialogArea
 * @description Renders the modal for creating a new area.
 * 
 * @component
 * @name TableAreas
 * @description Renders the table displaying existing areas.
 */
export const Areas = () => {

  // USE STATE 
  const [modalCreate, setModalCreate] = useState(false);
  const [canCreate, setCanCreate] = useState(false);
  

  // USE EFFECT 
  useEffect(() => {
    hasPrmissionsCreate();
  }, []);


  // CONST FUNCTIONS 
  const hasPrmissionsCreate = async() => {

    const hasPermissions = await hasPemissions('modulo.configuracion', 'modulo.areas', 'create' );

    if ( hasPermissions ) {
         setCanCreate(true);
    }

  }
  
  // FUNCTIONS OPEN MODALS 
  const openModal = () => {
       setModalCreate(true);
  }

  const handleCloseModalCrear = () => {
        setModalCreate(false);
  } 
  


  return (
    <div>
        
        <BreadCrumbsAndTitle
                      title="Listado Areas" 
                      mainModule="configuracion" 
                      parent="Listado Areas"
                      action="" />

        {
           canCreate && <div style={{ display: 'flex', justifyContent: 'end'}}>
                          <Button  variant='contained' sx={{ marginBottom: 3 }} onClick={openModal}>Crear Area</Button>
                        </div>
        }

        <AlertsInformativos type={'info'} title={'info'} content={alertInformativo.area} /> 
        <Divider sx={{ marginBottom: mtDividerUpTable }}/>
        <DialogArea open={modalCreate} handleCloseModalCrear={handleCloseModalCrear} />
         
        <TableAreas />
    </div>
  )
}
